import React from "react";
import {Button, Grid, TextField, Typography, useTheme} from "@material-ui/core";
import ProgressOr from "../../../components/ProgressOr";
import Widget from "../../../components/BetterWidget";
import {Customers} from "../../../context/CustomersContext";

class AddCustomer extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            saving: false,
            disabled: true
        }
    }

    setName(e){
        const name = e.target.value
        this.setState({
            name: name,
            disabled: !/\w+/.test(name)
        })
    }

    async save(){
        this.setState({saving: true})
        const customers = await this.props.customers.fetchCustomers()
        this.props.history.push({
            pathname: 'edit-customer',
            state: await customers.add(this.state.name)
        })
    }

    render() {
        const {name, saving, disabled} = this.state
        return (
            <div>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="h1">
                            Add Customer
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Widget>
                            <Grid container spacing={2} style={{maxWidth:600}}>
                                <Grid item xs={12}>
                                    <TextField
                                        value={name}
                                        onChange={this.setName.bind(this)}
                                        variant="outlined"
                                        label="Customer Name"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} style={{textAlign: "right"}}>
                                    <ProgressOr showProgress={saving} progressMessage={`Saving ${name}...`}>
                                        <Button
                                            onClick={() => this.props.history.go(-1)}
                                            variant="contained"
                                            style={{marginRight:this.props.theme.spacing(2)}}
                                        >Cancel</Button>
                                        <Button disabled={disabled} color="primary" variant="contained" onClick={this.save.bind(this)}>Save</Button>
                                    </ProgressOr>
                                </Grid>
                            </Grid>
                        </Widget>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

export default (props) => {
    const theme = useTheme()
    return (
        <Customers.Consumer>
            {
                customers => <AddCustomer theme={theme} customers={customers} {...props}/>
            }
        </Customers.Consumer>
    )
}